export const BASE_CLASS = 'mt-CardAlert'
